import { BYDB_US_MARKET_HOSTS } from '@/constants/config'
import { LOCALES } from '@/constants/locales'

const getCampaignDate = (date: string, time: string) =>
  new Date(`${date}:${time}+01:00`)

const BYDB_US_MARKET_CAMPAIGN_DATE_OVERRIDES = {
  startAt: getCampaignDate('2026-07-20', '12:00'),
  closeAt: getCampaignDate('2026-09-01', '07:59'),
}

const BYDB_DEFAULT_MARKET_LOCALES: Record<string, Locale> = {
  'taylormadegolf.partnership-hub.co.uk': LOCALES.EN,
  'taylormadegolf.partnership-hub.com': LOCALES.IE,
}

const normalizeHost = (host?: string | string[]) =>
  (Array.isArray(host) ? host[0] : host)
    ?.split(',')[0]
    ?.trim()
    ?.toLowerCase()
    ?.replace(/:\d+$/, '')

const matchesHost = (host: string, configuredHost: string) => {
  const normalizedConfiguredHost = configuredHost.replace(/:\d+$/, '')

  if (normalizedConfiguredHost.startsWith('*.')) {
    const suffix = normalizedConfiguredHost.slice(1)
    return host.endsWith(suffix)
  }

  return host === normalizedConfiguredHost
}

export const isBydbUsMarketHost = (host?: string | string[]) => {
  const normalizedHost = normalizeHost(host)

  if (!normalizedHost) {
    return false
  }

  return BYDB_US_MARKET_HOSTS.some((configuredHost) =>
    matchesHost(normalizedHost, configuredHost),
  )
}

export const getBydbMarketLocale = (
  ctx: Pick<GetServerSidePropsContext, 'req'>,
) => {
  const host =
    ctx.req.headers['x-forwarded-host'] ?? ctx.req.headers['host'] ?? ''

  return isBydbUsMarketHost(host) ? LOCALES.US : null
}

export const getBydbDefaultLocale = (
  ctx: Pick<GetServerSidePropsContext, 'req'>,
) => {
  const host =
    ctx.req.headers['x-forwarded-host'] ?? ctx.req.headers['host'] ?? ''

  return BYDB_DEFAULT_MARKET_LOCALES[normalizeHost(host) ?? ''] ?? null
}

export const getBydbCampaignDateOverrides = (locale?: string) =>
  locale === LOCALES.US ? BYDB_US_MARKET_CAMPAIGN_DATE_OVERRIDES : undefined

export const getBydbAssetLocale = (locale?: string) =>
  locale === LOCALES.US ? LOCALES.EN : locale
